class ClearSelectionCommand {
  constructor(receiver, controller) {
    this.receiver = receiver;
    this.controller = controller;
  }
  execute() {
    this.controller.unSelectObjects();
  }
  undo() {
    this.controller.selectObjects(this.receiver);
  }
}

export default ClearSelectionCommand;
